import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { FaConnectdevelop, FaDatabase, FaFileCode, FaGithubSquare, FaLinkedin, FaOpencart, FaReact, FaTrafficLight, FaTwitterSquare } from "react-icons/fa";
import webdesign from "../../img/FinalEdit/full stackOne.png";
import mainTwo from "../../img/FinalEdit/mainTwo.png";
import story from "../../img/FinalEdit/story.png";
import designSkills from "../../img/FinalEdit/uiSkills.png";

const HomeDataLoad = (props) => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  console.log(props.intro);
  const {
    name,
    javascript,
    mongodb,
    reactjs,
    nodejs,
    express,
    html,
    css,
    bootstrap,
    material,
    illustrator,
    photoshop,
    xd,
    tailwind,
  } = props.intro;

  return (
    <>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12">
        <div data-aos="fade-up" className="">
          <h1
            data-aos="fade-right"
            className="font-bold text-gray-900 mb-8 text-5xl md:text-6xl lg:text-7xl"
          >
            {name}
          </h1>
          <p
            data-aos="fade-left"
            className="text-gray-500 font-bold sm:text-base md:text-3xl lg:text-5xl"
          >
            A full time coder & Web-Devoloper.I like to make web
            Applications.Mostly React Js & Node Js
          </p>
          <div className="flex my-8">
            <a target="_blank" href="https://github.com/mdrianislam0or1" rel="noreferrer">
              <FaGithubSquare className=" text-gray-800  sm:text-4xl md:text-4xl lg:text-5xl" />
            </a>
            <a target="_blank" href="https://twitter.com/mdrianislam0or1" rel="noreferrer">
              <FaTwitterSquare className="text-blue-500 mx-3 sm:text-4xl md:text-4xl lg:text-5xl" />
            </a>
            <a target="_blank" href="https://www.linkedin.com/in/mdrianislam0or1/" rel="noreferrer">
              <FaLinkedin className="text-blue-500  sm:text-4xl md:text-4xl lg:text-5xl" />
            </a>
          </div>

          <a
            target="_blank"
            href="https://drive.google.com/file/d/1Lk8LlvpJQaZ7JNVBhAtSipVPUzfS21qg/view?usp=sharing" rel="noreferrer"
          >
            <button className="animate-bounce bg-transparent hover:bg-gray-800 text-gray-800 font-semibold hover:text-white py-2 px-4 border border-gray-800 hover:border-transparent rounded">
              See My Resume
            </button>
          </a>
        </div>
        <div data-aos="fade-down" className="">
          <img className="object-contain h-full w-full" src={mainTwo} alt="" />
        </div>
      </div>

      {/* Second Section */}
      <div >
        <div className=" my-20">
          <h1
            data-aos="flip-left"
            className="text-center font-bold text-5xl md:text-6xl lg:text-7xl"
          >
            My Story
          </h1>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12">
          <div data-aos="fade-right" className="sm:pt-2 md:pt-20 lg:pt-20">
            {/* <h1 data-aos="fade-right"  className="mt-6 pt-6   mb-2 font-bold text-4xl md:text-5xl lg:text-5xl">
          My Story
        </h1> */}

            <p className=" text-gray-500 sm:text-base md:text-2xl lg:text-2xl">
            I'm a Muslim who believes in Allah and the prophet
              Mohammad.
              I began my CSE study with a Blank Canvas in 2019.
              I am a developer with solid experience of building back-end and front-end of applications.
              I am most fluent in Javascript and Python related technologies.
               I Love writing clean and maintainable code for the
              web, passionate about learning and exploring new technologies.
              
            </p>
          </div>

          <div data-aos="fade-up">
            <img src={story} alt="" />
          </div>
        </div>
      </div>

      {/* Third Section */}
      <h1
        data-aos="fade-right"
        className="mt-6 pt-6   mb-2 font-bold text-4xl md:text-5xl lg:text-5xl"
      >
        Technical Skills
      </h1>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12">
        {/* Skills first row */}
        <div>
          <div data-aos="fade-right" className="rounded border-t-4 border-purple-400 card bg-green-300 hover:shadow-lg">
            <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaFileCode className=" text-red-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Programming Languages
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
                JavaScript (ES6+), TypeScript, Python, C/C++
              </h1>
            </div>
          </div>
          <div data-aos="fade-right" className="rounded border-t-4 border-pink-400 card bg-red-100 hover:shadow-lg">
            <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaDatabase className=" text-green-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Databases
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
                MongoDB,MySql
              </h1>
            </div>
          </div>
          <div data-aos="fade-right" className="rounded border-t-4 border-blue-400 card bg-pink-300 hover:shadow-lg">
            <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaOpencart className=" text-pink-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Design Tools
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
              Adobe Illustrator,Adobe Photoshop,Adobe XD
              </h1>
            </div>
          </div>
        </div>

        <div>
          <div data-aos="fade-left" className="rounded border-t-4 border-gray-400 card bg-purple-300 hover:shadow-lg">
          <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaReact className=" text-blue-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Libraries & Frameworks
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
              React, React Native, NextJS, Express, Flask, Tailwind, Bootstrap, etc
              </h1>
            </div>
          </div>
          <div data-aos="fade-left" className="rounded border-t-4 border-red-400 card bg-yellow-100 hover:shadow-lg">
          <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaConnectdevelop className=" text-gray-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Dev Tools
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
              Git, Github, Docker, Firebase,Heroku, REST etc
              </h1>
            </div>
          </div>
          <div data-aos="fade-left" className="rounded border-t-4 border-indigo-400 card bg-blue-300 hover:shadow-lg">
          <div className="m-4">
              <h1 className="py-3 text-2xl font-bold flex">
                <FaTrafficLight className=" text-blue-500  sm:text-4xl md:text-3xl lg:text-4xl" />
                Miscellaneous
              </h1>
              <h1 className="py-1 block text-gray-500 text-sm">
              Kali Linux,Burp Suite,CLI
              </h1>
            </div>
          </div>
        </div>
        
      </div>

      {/* //Fourth SECTION */}

      <div className=" my-20">
        <h1
          data-aos="flip-right"
          className="text-center font-bold text-5xl md:text-6xl lg:text-7xl"
        >
          What I do
        </h1>
      </div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12">
        <div data-aos="fade-down">
          <img
            src={webdesign}
            className="object-contain h-full w-full "
            alt=""
          />
        </div>
        <div data-aos="fade-up">
          <h1
            data-aos="flip-left"
            className="lg:mt-20 lg:pt-20 font-bold text-4xl md:text-5xl lg:text-6xl"
          >
            Full Stack Development
          </h1>
          <div data-aos="fade-left" className="my-4 flex items-center">
            <div className="">
              <img
                className="object-contain h-12 w-12 "
                src={javascript}
                alt=""
              />
            </div>
            <div className="mx-4">
              <img className="object-contain h-12 w-12 " src={reactjs} alt="" />
            </div>
            <div className="mx-4">
              <img className="object-contain h-12 w-12 " src={nodejs} alt="" />
            </div>
            <div className="mx-4">
              <img className="object-contain h-12 w-12 " src={mongodb} alt="" />
            </div>
            <div className="mx-4">
              <img className="object-contain h-12 w-12 " src={express} alt="" />
            </div>
          </div>

          <div data-aos="fade-right" className="my-4 flex items-center">
            <div className="">
              <img className="object-contain h-12 w-12 " src={html} alt="" />
            </div>
            <div className="mx-4">
              <img className="object-contain h-12 w-12 " src={css} alt="" />
            </div>
            <div className="mx-4">
              <img
                className="object-contain h-12 w-12 "
                src={bootstrap}
                alt=""
              />
            </div>
            <div className="mx-4">
              <img
                className="object-contain h-12 w-12 "
                src={tailwind}
                alt=""
              />
            </div>
            <div className="mx-4">
              <img
                className="object-contain h-12 w-12 "
                src={material}
                alt=""
              />
            </div>
          </div>

          <div data-aos="flip-right" className="mt-12 mb-10">
            <p className=" text-gray-500 sm:text-base md:text-2xl lg:text-2xl">
            🌠 Building resposive website front end using React Js
            </p>
            <p className=" text-gray-500 sm:text-base md:text-2xl lg:text-2xl">
            🌠 Creating application backend in Node, Express & MongoDB
            </p>
          </div>
        </div>
      </div>

      {/* //FIFTH SECTION */}

      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12">
        <div className="mt-20 pt-12" data-aos="fade-up">
          <img
            className="object-contain h-full w-full"
            src={designSkills}
            alt=""
          />
        </div>
        <div className=" md:mt-20 md:pt-20" data-aos="fade-up">
          <h1
            data-aos="flip-right"
            className="mt-6 pt-6   mb-2 font-bold text-4xl md:text-5xl lg:text-6xl"
          >
            Design
          </h1>
          <div className="flex items-center">
            <div className="">
              <img
                className="object-contain h-12 w-12 "
                src={illustrator}
                alt=""
              />
            </div>
            <div className="px-4">
              <img
                className="object-contain h-12 w-12 "
                src={photoshop}
                alt=""
              />
            </div>
            <div className="">
              <img className="object-contain h-12 w-12 " src={xd} alt="" />
            </div>
          </div>

          <div data-aos="flip-right" className="my-12">
            <p className=" text-gray-500 sm:text-base md:text-2xl lg:text-2xl">
            🌠 Designing user interface web applications & Customizing logo
              designs and illustration
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeDataLoad;
